export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 2_00.98a9cbf3.jpg";